import module from 'empresa/module.js'

export const schema = {}


export default class EmpresaInformacionSatCertificadoService {
  constructor ($http) {
    this.$http = $http
  }

  delete (empresaId, descripcion, tipo) {
    return this.$http.delete('/api/empresa/informacion/sat/certificado', {
      params: {
        empresa_id: empresaId,
        descripcion: descripcion,
        tipo: tipo,
      },
    })
  }
}

module.service('EmpresaInformacionSatCertificado', EmpresaInformacionSatCertificadoService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Informacion/Sat/Certificado.js